export default "__VITE_ASSET__d9cbcf7e__"